import { render } from "./ListeBonRetour.vue?vue&type=template&id=08d83d4c&ts=true"
import script from "./ListeBonRetour.vue?vue&type=script&lang=ts"
export * from "./ListeBonRetour.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__